import React, { useState, useEffect } from 'react';
import ErrorMessage from './ErrorMessage';
import GroupService from '../Services/UserGroup/GroupService';
import RedirectLinkComponent from './RedirectLinkComponent';

const GroupNameComponent = ({ groupId = null }) => {
  const [groupName, setGroupName] = useState(groupId);

  useEffect(() => {
    if (!groupId) {
      setGroupName(groupId);
      return;
    }
    GroupService.GetById(groupId)
      .then((result) => {
        if (!result || !result.name) {
          // The group no longer exists (deleted but still referenced) — show the raw id, it is not a call failure
          setGroupName(groupId);
          return;
        }
        setGroupName(`${result.name} (${groupId})`);
      })
      .catch(() => {
        setGroupName(groupId);
        ErrorMessage.SetErrorMessage('GNC36');
      });
  }, [groupId]);

  return (
    <RedirectLinkComponent
      isFigmaStyle={true}
      path='user_groups'
      tooltipText={groupId}
      text={groupName}
      keyValuePairs={[{ key: 'GroupIdOrName', value: groupId }]}
    />
  );
};

export default GroupNameComponent;
